import { render, staticRenderFns } from "./Nps.vue?vue&type=template&id=3b4ae027&scoped=true&"
import script from "./Nps.vue?vue&type=script&lang=js&"
export * from "./Nps.vue?vue&type=script&lang=js&"
import style0 from "./Nps.vue?vue&type=style&index=0&id=3b4ae027&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4ae027",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b4ae027')) {
      api.createRecord('3b4ae027', component.options)
    } else {
      api.reload('3b4ae027', component.options)
    }
    module.hot.accept("./Nps.vue?vue&type=template&id=3b4ae027&scoped=true&", function () {
      api.rerender('3b4ae027', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Nps.vue"
export default component.exports